module.exports = __webpack_public_path__ + "img/42600.6065c0d1.jpg";